import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { GuestGuard } from '@src/components';

export default function AuthLayout({ children }) {
  return (
    <GuestGuard>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          background:
            'radial-gradient(1200px 600px at 15% -10%, rgba(243, 115, 50, 0.12), transparent 60%), radial-gradient(1000px 500px at 110% 110%, rgba(243, 115, 50, 0.10), transparent 60%), var(--mui-palette-background-level1)',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '440px',
            bgcolor: 'var(--mui-palette-background-paper)',
            borderRadius: '20px',
            boxShadow: 'var(--mui-shadows-16)',
            p: { xs: 3, sm: 5 },
            // Brand-orange primary, scoped to the auth card only
            '--mui-palette-primary-main': '#F37332',
            '--mui-palette-primary-light': '#F79059',
            '--mui-palette-primary-dark': '#DA5E1E',
            '--mui-palette-primary-contrastText': '#FFFFFF',
            '--mui-palette-primary-mainChannel': '243 115 50',
            '--mui-palette-primary-lightChannel': '247 144 89',
            '--mui-palette-primary-darkChannel': '218 94 30',
          }}
        >
          {children}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          © {new Date().getFullYear()} Lead Gurus
        </Typography>
      </Box>
    </GuestGuard>
  );
}
